// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-holder {
  position: relative;
  height: 100vh;
  background: #0a0a14;
  overflow-y: scroll;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */ }
  .sidebar-holder::-webkit-scrollbar {
    display: none; }
  .sidebar-holder .sidebar-navigation {
    max-height: calc(100% - 40px);
    overflow-y: auto;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */ }
    .sidebar-holder .sidebar-navigation::-webkit-scrollbar {
      display: none; }
  .sidebar-holder .sidebar-header {
    display: flex;
    justify-content: center;
    padding-block: 10px 5px;
    line-height: 26px;
    -webkit-text-decoration: dotted;
            text-decoration: dotted;
    border-bottom: 1px solid #3f3f3f; }
  .sidebar-holder .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: transparent; }
  .sidebar-holder .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected .btn {
    color: #ededed;
    font-weight: 600; }
  .sidebar-holder .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected .img {
    filter: opacity(1); }
  .sidebar-holder .img {
    filter: opacity(0.5); }
  .sidebar-holder .logout-btn-wrapper {
    position: absolute;
    bottom: 0; }
  .sidebar-holder .logout-button {
    padding: 0;
    left: 21px;
    text-align: left;
    color: rgba(255, 255, 255, 0.65); }
    .sidebar-holder .logout-button:hover {
      color: #ffffff; }
  .sidebar-holder .logo-text {
    font-size: 14px;
    font-weight: bold;
    font-family: 'Proxima Nova';
    font-style: normal;
    line-height: 14px;
    color: #ffffff;
    display: flex;
    align-items: center; }
    .sidebar-holder .logo-text img {
      margin-right: 5px; }
    .sidebar-holder .logo-text .subheading {
      margin-top: 8px;
      font-size: 16px;
      color: #efefef; }
  .sidebar-holder .dropdown-wrapper .dropdown-btn {
    color: #ffffff !important;
    border-radius: 0px !important;
    background: transparent;
    border: none;
    padding: 0 4px; }
    .sidebar-holder .dropdown-wrapper .dropdown-btn span {
      font-size: 14px;
      font-weight: 700; }
    .sidebar-holder .dropdown-wrapper .dropdown-btn:hover, .sidebar-holder .dropdown-wrapper .dropdown-btn:focus {
      border: none; }
  .sidebar-holder .dropdown-wrapper .checkbox-wrapper {
    margin-left: -40px;
    color: #484848;
    padding: 18px;
    margin-top: 10px; }
    .sidebar-holder .dropdown-wrapper .checkbox-wrapper li {
      font-size: 16px;
      font-family: 'Proxima Nova'; }
`, "",{"version":3,"sources":["webpack://./src/components/SideBar/styles.scss"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EAAE,gBAAA;EAC1B,qBAAqB;EAAE,YAAA,EAAa;EANxC;IASQ,aAAa,EAAA;EATrB;IAaQ,6BAA6B;IAC7B,gBAAgB;IAChB,wBAAwB;IAAE,gBAAA;IAC1B,qBAAqB;IAAE,YAAA,EAAa;IAhB5C;MAmBY,aAAa,EAAA;EAnBzB;IAwBQ,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,+BAAuB;YAAvB,uBAAuB;IACvB,gCAAgC,EAAA;EA7BxC;IAiCQ,6BAA6B,EAAA;EAjCrC;IAqCQ,cAAc;IACd,gBAAgB,EAAA;EAtCxB;IA0CQ,kBAAkB,EAAA;EA1C1B;IA8CQ,oBAAoB,EAAA;EA9C5B;IAkDQ,kBAAkB;IAClB,SAAS,EAAA;EAnDjB;IAuDQ,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,gCAAgC,EAAA;IA1DxC;MA6DY,cAAc,EAAA;EA7D1B;IAkEQ,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB,EAAA;IAzE3B;MA4EY,iBAAiB,EAAA;IA5E7B;MAgFY,eAAe;MACf,eAAe;MACf,cAAc,EAAA;EAlF1B;IAwFY,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;IACvB,YAAY;IACZ,cAAc,EAAA;IA5F1B;MA+FgB,eAAe;MACf,gBAAgB,EAAA;IAhGhC;MAqGgB,YAAY,EAAA;EArG5B;IA0GY,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,gBAAgB,EAAA;IA7G5B;MAgHgB,eAAe;MACf,2BAA2B,EAAA","sourcesContent":[".sidebar-holder {\n    position: relative;\n    height: 100vh;\n    background: #0a0a14;\n    overflow-y: scroll;\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n\n    &::-webkit-scrollbar {\n        display: none;\n    }\n\n    .sidebar-navigation {\n        max-height: calc(100% - 40px);\n        overflow-y: auto;\n        -ms-overflow-style: none; /* IE and Edge */\n        scrollbar-width: none; /* Firefox */\n\n        &::-webkit-scrollbar {\n            display: none;\n        }\n    }\n\n    .sidebar-header {\n        display: flex;\n        justify-content: center;\n        padding-block: 10px 5px;\n        line-height: 26px;\n        text-decoration: dotted;\n        border-bottom: 1px solid #3f3f3f;\n    }\n\n    .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\n        background-color: transparent;\n    }\n\n    .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected .btn {\n        color: #ededed;\n        font-weight: 600;\n    }\n\n    .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected .img {\n        filter: opacity(1);\n    }\n\n    .img {\n        filter: opacity(0.5);\n    }\n\n    .logout-btn-wrapper {\n        position: absolute;\n        bottom: 0;\n    }\n\n    .logout-button {\n        padding: 0;\n        left: 21px;\n        text-align: left;\n        color: rgba(255, 255, 255, 0.65);\n\n        &:hover {\n            color: #ffffff;\n        }\n    }\n\n    .logo-text {\n        font-size: 14px;\n        font-weight: bold;\n        font-family: 'Proxima Nova';\n        font-style: normal;\n        line-height: 14px;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n\n        img {\n            margin-right: 5px;\n        }\n\n        .subheading {\n            margin-top: 8px;\n            font-size: 16px;\n            color: #efefef;\n        }\n    }\n\n    .dropdown-wrapper {\n        .dropdown-btn {\n            color: #ffffff !important;\n            border-radius: 0px !important;\n            background: transparent;\n            border: none;\n            padding: 0 4px;\n\n            span {\n                font-size: 14px;\n                font-weight: 700;\n            }\n\n            &:hover,\n            &:focus {\n                border: none;\n            }\n        }\n\n        .checkbox-wrapper {\n            margin-left: -40px;\n            color: #484848;\n            padding: 18px;\n            margin-top: 10px;\n\n            li {\n                font-size: 16px;\n                font-family: 'Proxima Nova';\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
